import styled from "styled-components";
import { textBlack } from "styles/colors";

interface Styles {
  color?: string;
  fontWeight?: number;
}

export const TextColorWrapper = styled.span<Styles>`
  color: ${({ color }) => color || textBlack};
  font-weight: ${({ fontWeight }) => fontWeight || 400};
`;